module.exports = __webpack_public_path__ + "static/media/portrait3.df53fc77.jpg";